import {
    faSolidAnchor,
    faSolidAngleLeft,
    faSolidAngleRight,
    faSolidAngleUp,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowTrendUp,
    faSolidArrowsRotate,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidBus,
    faSolidCalendarCheck,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidChartBar,
    faSolidCheck,
    faSolidCheckToSlot,
    faSolidCircle,
    faSolidCircleCheck,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCirclePlay,
    faSolidCircleQuestion,
    faSolidCircleUser,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidClock,
    faSolidClockRotateLeft,
    faSolidClone,
    faSolidCompress,
    faSolidCopy,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidEyeSlash,
    faSolidFile,
    faSolidFileCirclePlus,
    faSolidFileCsv,
    faSolidFileExcel,
    faSolidFileImport,
    faSolidFileInvoice,
    faSolidFileInvoiceDollar,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilePen,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidFolder,
    faSolidGauge,
    faSolidGear,
    faSolidHammer,
    faSolidHand,
    faSolidHouse,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLightbulb,
    faSolidLink,
    faSolidList,
    faSolidListCheck,
    faSolidLocationDot,
    faSolidLockOpen,
    faSolidMagnifyingGlass,
    faSolidMoon,
    faSolidPaperclip,
    faSolidPassport,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlus,
    faSolidPrint,
    faSolidQuestion,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShieldHalved,
    faSolidShip,
    faSolidSortDown,
    faSolidSun,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTrailer,
    faSolidTrain,
    faSolidTrash,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUsers,
    faSolidVanShuttle,
    faSolidWarehouse,
    faSolidXmark
} from '@ng-icons/font-awesome/solid';

import { bootstrapApple, bootstrapFacebook, bootstrapGoogle } from '@ng-icons/bootstrap-icons';

const icons: Record<string, string> = {
    bootstrapApple,
    bootstrapFacebook,
    bootstrapGoogle,
    faSolidAnchor,
    faSolidAngleLeft,
    faSolidAngleRight,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidAngleUp,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowsRotate,
    faSolidArrowTrendUp,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidBus,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidCalendarCheck,
    faSolidChartBar,
    faSolidCheck,
    faSolidCheckToSlot,
    faSolidCircle,
    faSolidCircleCheck,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCircleQuestion,
    faSolidCirclePlay,
    faSolidCircleUser,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidClock,
    faSolidClockRotateLeft,
    faSolidClone,
    faSolidCompress,
    faSolidCopy,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidEyeSlash,
    faSolidFile,
    faSolidFileExcel,
    faSolidFileCirclePlus,
    faSolidFileCsv,
    faSolidFileInvoice,
    faSolidFileInvoiceDollar,
    faSolidFileImport,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilePen,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidFolder,
    faSolidGauge,
    faSolidGear,
    faSolidHammer,
    faSolidHand,
    faSolidHouse,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLightbulb,
    faSolidLink,
    faSolidList,
    faSolidListCheck,
    faSolidLocationDot,
    faSolidLockOpen,
    faSolidMagnifyingGlass,
    faSolidMoon,
    faSolidPaperclip,
    faSolidPassport,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlus,
    faSolidPrint,
    faSolidQuestion,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShieldHalved,
    faSolidShip,
    faSolidSortDown,
    faSolidSun,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTrailer,
    faSolidTrain,
    faSolidTrash,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUsers,
    faSolidVanShuttle,
    faSolidWarehouse,
    faSolidXmark
};

export default icons;

export type IconKey =
    | 'bootstrapApple'
    | 'bootstrapFacebook'
    | 'bootstrapGoogle'
    | 'faSolidAnchor'
    | 'faSolidAngleLeft'
    | 'faSolidAngleRight'
    | 'faSolidAnglesLeft'
    | 'faSolidAnglesRight'
    | 'faSolidAngleUp'
    | 'faSolidArrowRightArrowLeft'
    | 'faSolidArrowRightFromBracket'
    | 'faSolidArrowRightToBracket'
    | 'faSolidArrowRotateLeft'
    | 'faSolidArrowTrendUp'
    | 'faSolidArrowsRotate'
    | 'faSolidArrowsTurnToDots'
    | 'faSolidBan'
    | 'faSolidBars'
    | 'faSolidBatteryEmpty'
    | 'faSolidBatteryFull'
    | 'faSolidBell'
    | 'faSolidBellSlash'
    | 'faSolidBook'
    | 'faSolidBox'
    | 'faSolidBoxArchive'
    | 'faSolidBoxOpen'
    | 'faSolidBoxesStacked'
    | 'faSolidBuilding'
    | 'faSolidBullhorn'
    | 'faSolidBus'
    | 'faSolidCar'
    | 'faSolidCaretDown'
    | 'faSolidCaretUp'
    | 'faSolidCalendarCheck'
    | 'faSolidChartBar'
    | 'faSolidCheck'
    | 'faSolidCheckToSlot'
    | 'faSolidCircle'
    | 'faSolidCircleCheck'
    | 'faSolidCircleExclamation'
    | 'faSolidCircleInfo'
    | 'faSolidCircleQuestion'
    | 'faSolidCirclePlay'
    | 'faSolidCircleUser'
    | 'faSolidCircleXmark'
    | 'faSolidClipboardList'
    | 'faSolidClock'
    | 'faSolidClockRotateLeft'
    | 'faSolidClone'
    | 'faSolidCompress'
    | 'faSolidCopy'
    | 'faSolidCube'
    | 'faSolidDatabase'
    | 'faSolidDownload'
    | 'faSolidEnvelope'
    | 'faSolidEnvelopeCircleCheck'
    | 'faSolidEnvelopeOpen'
    | 'faSolidExclamation'
    | 'faSolidExpand'
    | 'faSolidEye'
    | 'faSolidEyeSlash'
    | 'faSolidFile'
    | 'faSolidFileExcel'
    | 'faSolidFileCirclePlus'
    | 'faSolidFileCsv'
    | 'faSolidFileInvoice'
    | 'faSolidFileInvoiceDollar'
    | 'faSolidFileImport'
    | 'faSolidFileLines'
    | 'faSolidFilePdf'
    | 'faSolidFilePen'
    | 'faSolidFilter'
    | 'faSolidFilterCircleXmark'
    | 'faSolidFire'
    | 'faSolidFireFlameCurved'
    | 'faSolidFloppyDisk'
    | 'faSolidFolder'
    | 'faSolidGauge'
    | 'faSolidGear'
    | 'faSolidHammer'
    | 'faSolidHand'
    | 'faSolidHouse'
    | 'faSolidInbox'
    | 'faSolidKey'
    | 'faSolidLanguage'
    | 'faSolidLightbulb'
    | 'faSolidLink'
    | 'faSolidList'
    | 'faSolidListCheck'
    | 'faSolidLocationDot'
    | 'faSolidLockOpen'
    | 'faSolidMagnifyingGlass'
    | 'faSolidMoon'
    | 'faSolidPaperclip'
    | 'faSolidPassport'
    | 'faSolidPenToSquare'
    | 'faSolidPersonMilitaryPointing'
    | 'faSolidPlaneArrival'
    | 'faSolidPlaneDeparture'
    | 'faSolidPlus'
    | 'faSolidPrint'
    | 'faSolidQuestion'
    | 'faSolidScrewdriverWrench'
    | 'faSolidShare'
    | 'faSolidShieldHalved'
    | 'faSolidShip'
    | 'faSolidSortDown'
    | 'faSolidSun'
    | 'faSolidTableColumns'
    | 'faSolidTags'
    | 'faSolidThumbsDown'
    | 'faSolidThumbsUp'
    | 'faSolidThumbtack'
    | 'faSolidTrailer'
    | 'faSolidTrain'
    | 'faSolidTrash'
    | 'faSolidTruck'
    | 'faSolidTruckRampBox'
    | 'faSolidUpload'
    | 'faSolidUser'
    | 'faSolidUserPlus'
    | 'faSolidUsers'
    | 'faSolidVanShuttle'
    | 'faSolidWarehouse'
    | 'faSolidXmark';
